import { createStructuredSelector } from 'reselect'

import {
  REQUEST_DETAIL_ECO_LIST,
  REQUEST_DETAIL_ECO_LIST_SUCCESS,
  REQUEST_DETAIL_ECO_LIST_ERROR,
  REQUEST_DETAIL_ECO_PAGE_SET,
  REQUEST_DETAIL_ECO_SEARCH_SET,
  REQUEST_DETAIL_ECO_SEARCH_CHANGE,
  REQUEST_DETAIL_ECO_SEARCH_GEO_COUNTRY_LIST,
  REQUEST_DETAIL_ECO_SEARCH_GEO_COUNTRY_LIST_SUCCESS,
  REQUEST_DETAIL_ECO_SEARCH_GEO_COUNTRY_LIST_ERROR,
  REQUEST_DETAIL_ECO_SEARCH_HEALTH_AGENCY_LIST,
  REQUEST_DETAIL_ECO_SEARCH_HEALTH_AGENCY_LIST_SUCCESS,
  REQUEST_DETAIL_ECO_SEARCH_HEALTH_AGENCY_LIST_ERROR,
  REQUEST_DETAIL_ECO_ADD_SET,
  REQUEST_DETAIL_ECO_ADD_MODAL_SET,
  REQUEST_DETAIL_ECO_ADD,
  REQUEST_DETAIL_ECO_ADD_SUCCESS,
  REQUEST_DETAIL_ECO_ADD_ERROR,
  REQUEST_DETAIL_ECO_ADD_CHANGE,
  REQUEST_DETAIL_ECO_DETAIL,
  REQUEST_DETAIL_ECO_DETAIL_SUCCESS,
  REQUEST_DETAIL_ECO_DETAIL_ERROR,
  REQUEST_DETAIL_ECO_VIEW_MODAL_SET,
  REQUEST_DETAIL_ECO_EDIT_CHANGE,
  REQUEST_DETAIL_ECO_EDIT_MODAL_SET,
  REQUEST_DETAIL_ECO_UPDATE,
  REQUEST_DETAIL_ECO_UPDATE_SUCCESS,
  REQUEST_DETAIL_ECO_UPDATE_ERROR,
  REQUEST_DETAIL_ECO_VIEW_TAB_SET
} from '../actions';

export const NAME = 'request_detail_eco';

export const RequestDetailEcoList = (page, num_page, orderBy, filters, stateFilter, display) => ({
  type: REQUEST_DETAIL_ECO_LIST,
  payload: { page: page, num_page: num_page, orderBy: orderBy, filters: filters, filtersState: stateFilter, display: display }
});

export const RequestDetailEcoListSuccess = (data) => ({
  type: REQUEST_DETAIL_ECO_LIST_SUCCESS,
  payload: data
});

export const RequestDetailEcoListError = (error) => ({
  type: REQUEST_DETAIL_ECO_LIST_ERROR,
  payload: error
});

export const RequestDetailEcoPageSet = (data) => ({
  type: REQUEST_DETAIL_ECO_PAGE_SET,
  payload: data
});

export const RequestDetailEcoSearchSet = (data) => ({
  type: REQUEST_DETAIL_ECO_SEARCH_SET,
  payload: data
});

export const RequestDetailEcoSearchChangeSet = (data) => ({
  type: REQUEST_DETAIL_ECO_SEARCH_CHANGE,
  payload: data
});

export const RequestDetailEcoSearchGeoCountryList = (data) => ({
  type: REQUEST_DETAIL_ECO_SEARCH_GEO_COUNTRY_LIST,
  payload: data
});

export const RequestDetailEcoSearchGeoCountryListSuccess = (message) => ({
  type: REQUEST_DETAIL_ECO_SEARCH_GEO_COUNTRY_LIST_SUCCESS,
  payload: message
});

export const RequestDetailEcoSearchGeoCountryListError = (error) => ({
  type: REQUEST_DETAIL_ECO_SEARCH_GEO_COUNTRY_LIST_ERROR,
  payload: error
});

export const RequestDetailEcoSearchHealthAgencyList = (data) => ({
  type: REQUEST_DETAIL_ECO_SEARCH_HEALTH_AGENCY_LIST,
  payload: data
});

export const RequestDetailEcoSearchHealthAgencyListSuccess = (message) => ({
  type: REQUEST_DETAIL_ECO_SEARCH_HEALTH_AGENCY_LIST_SUCCESS,
  payload: message
});

export const RequestDetailEcoSearchHealthAgencyListError = (error) => ({
  type: REQUEST_DETAIL_ECO_SEARCH_HEALTH_AGENCY_LIST_ERROR,
  payload: error
});

export const RequestDetailEcoAddChangeSet = (data) => ({
  type: REQUEST_DETAIL_ECO_ADD_CHANGE,
  payload: data
});

export const RequestDetailEcoAddSet = (data) => ({
  type: REQUEST_DETAIL_ECO_ADD_SET,
  payload: data
});

export const RequestDetailEcoAddModalSet = (data) => ({
  type: REQUEST_DETAIL_ECO_ADD_MODAL_SET,
  payload: data
});

export const RequestDetailEcoAdd = (data) => ({
  type: REQUEST_DETAIL_ECO_ADD,
  payload: data
});

export const RequestDetailEcoAddSuccess = (message) => ({
  type: REQUEST_DETAIL_ECO_ADD_SUCCESS,
  payload: message
});

export const RequestDetailEcoAddError = (error) => ({
  type: REQUEST_DETAIL_ECO_ADD_ERROR,
  payload: error
});

export const RequestDetailEcoDetail = (data) => ({
  type: REQUEST_DETAIL_ECO_DETAIL,
  payload: data
});

export const RequestDetailEcoDetailSuccess = (data) => ({
  type: REQUEST_DETAIL_ECO_DETAIL_SUCCESS,
  payload: data
});

export const RequestDetailEcoDetailError = (error) => ({
  type: REQUEST_DETAIL_ECO_DETAIL_ERROR,
  payload: error
});

export const RequestDetailEcoViewModalSet = (data) => ({
  type: REQUEST_DETAIL_ECO_VIEW_MODAL_SET,
  payload: data
});

export const RequestDetailEcoEditModalSet = (data) => ({
  type: REQUEST_DETAIL_ECO_EDIT_MODAL_SET,
  payload: data
});

export const RequestDetailEcoEditChangeSet = (data) => ({
  type: REQUEST_DETAIL_ECO_EDIT_CHANGE,
  payload: data
});

export const RequestDetailEcoUpdate = (data) => ({
  type: REQUEST_DETAIL_ECO_UPDATE,
  payload: data
});

export const RequestDetailEcoUpdateSuccess = (message) => ({
  type: REQUEST_DETAIL_ECO_UPDATE_SUCCESS,
  payload: message.message
});

export const RequestDetailEcoUpdateError = (error) => ({
  type: REQUEST_DETAIL_ECO_UPDATE_ERROR,
  payload: error
});

export const RequestDetailEcoViewTabSet = (data) => ({
  type: REQUEST_DETAIL_ECO_VIEW_TAB_SET,
  payload: data
});

const request_detail_eco = (state) => state[NAME];

export const RequestDetailEcoSelector = createStructuredSelector({
  request_detail_eco
})
